import {IApplicationReducerData} from "../../types/IApplicationReducerData";
import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

export interface IGetAmplitudeCtaLeadFormTrackingContextParams {
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    leadData: IApplicationReducerData | undefined;
    ctaText: string;
    offerId?: number | null;
    propertyId?: number | null;
}

export const getAmplitudeCtaLeadFormTrackingContext = (params: IGetAmplitudeCtaLeadFormTrackingContextParams): IAmplitudeLeadFormTrackingContext | null => {
    const {source, sourceSection, leadData, ctaText} = params;
    const offerId = leadData?.offer?.detail?.id ?? params.offerId;
    const propertyId = leadData?.property?.detail?.id ?? params.propertyId;

    if (!offerId) {
        return null;
    }

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: ctaText,
        form_location: getAmplitudeFormLocation(leadData, propertyId ? "property_page" : "investment_page"),
        source_id: source,
        lead_type: getAmplitudeLeadType(sourceSection),
        item_id: offerId,
        ...(propertyId != null && {property_id: propertyId})
    };
};
import {IApplicationReducerData} from "../../types/IApplicationReducerData";
import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

export interface IGetAmplitudeCtaLeadFormTrackingContextParams {
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    leadData: IApplicationReducerData | undefined;
    ctaText: string;
    offerId?: number | null;
    propertyId?: number | null;
}

export const getAmplitudeCtaLeadFormTrackingContext = (params: IGetAmplitudeCtaLeadFormTrackingContextParams): IAmplitudeLeadFormTrackingContext | null => {
    const {source, sourceSection, leadData, ctaText} = params;
    const offerId = leadData?.offer?.detail?.id ?? params.offerId;
    const propertyId = leadData?.property?.detail?.id ?? params.propertyId;

    if (!offerId) {
        return null;
    }

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: ctaText,
        form_location: getAmplitudeFormLocation(leadData, propertyId ? "property_page" : "investment_page"),
        source_id: source,
        lead_type: getAmplitudeLeadType(sourceSection),
        item_id: offerId,
        ...(propertyId != null && {property_id: propertyId})
    };
};
